import { useQueries } from "@tanstack/react-query";
import { GET_CAREER_CLIMBS } from "../api/queries";
import { useReactQueryErrorReporter } from "./use-error-reporter";
import { graphQLClient } from "../index";

const fetchCareerClimbs = async ({ queryKey }) => {
  const [, { shardID, userPath }] = queryKey;

  const response = await graphQLClient.request(GET_CAREER_CLIMBS, {
    shardID,
    userPath,
  });

  return response.getCareerClimbsByShardId;
};

export const useGetAllDynamoClimbsAcrossClasses = (shardID, sections) => {
  const queries = useQueries({
    queries: (sections ?? []).map((section) => ({
      queryKey: ["careerClimbs", { shardID, userPath: section.id }],
      queryFn: fetchCareerClimbs,
      enabled: !!shardID && !!section.id,
    })),
  });

  const isLoading = queries.some((query) => query.isLoading);
  const isError = queries.some((query) => query.isError);
  const errors = queries
    .filter((query) => query.isError)
    .map((query) => query.error?.message);

  const mergedData = queries.flatMap((query) => query.data ?? []);

  useReactQueryErrorReporter(
    "Failed to fetch career climbs",
    isError ? errors : null,
  );

  return { data: mergedData, isLoading, isError, errors };
};
